import styled from 'styled-components'

export const DescriptionText = styled.p`
  font-size: 0.8rem;
  line-height: 1.1;
  margin-top: 5px;
`
